
export default {
	layout: 'whitelabel',
	props: {
		uuid: {
			type: String,
			default: null
		},
		searchbar: {
			type: Boolean,
			default: true
		},
		sort: {
			type: Boolean,
			default: true
		},
		pagination: {
			type: Boolean,
			default: true
		},
		byTag: {
			type: Boolean,
			default: true
		},
		set: {
			type: String,
			default: null
		},
		toggleGrid: {
			type: Boolean,
			default: false
		},
		eid: {
			type: String|Number,
			default: 0
		},
		initialFilter: { type: Object, default: () => ({}) }  // Added prop for initial filter
	},
	data() {
		return {
			isFetching: true,
			isChanging: false,
			errorFetching: false,
			courses: { items: [] },
			category: 'Courses',
			playerConfig: false,
			tags: {},
			filterTags: [],
			authorid: [],
			sortBy: false,
			hasPinForm: false,
			showActions: false,
			query: "",
			setQuery: "",
			selectedTags: [],
			selectedTagsFromQuery: [],
			noResults: false,
			educatorId: null,
			numPerPage: 8,
			showPerPage: true,
			gridView: true,
			paginationData: {
				totalRecords: 24,
				totalPages: 3,
				numPageOptions: 3,
			},
			pageNumber: 1,
			sortData: [],
			loggedIn: false,
			filterModal: false,
			currentHeaderSort: 'desc',
			showCartModal: false,
		}
	},
	head() {
		return {
			title: this.query ? this.query + ' Guitar Lessons' : 'Online Guitar Lessons'
		}
	},
	computed: {
		gridSize() {
			return this.byTag ? 'col-12 col-md-9' : 'col-12';
		},
		historyObj() {
			const obj = {
				tags: this.selectedTags,
				numPerPage: this.numPerPage,
				pageNumber: this.pageNumber
			}
			console.log('historyObj:', obj);
			return obj;
		}
	},
	methods: {
		openCartModal() {
			this.showCartModal = true;
		},
		filterObj() {
			try {
				if(this.$route.query.filter){
					return JSON.parse(this.$route.query.filter).filter;
				}
				if(this.initialFilter){
					return this.initialFilter;
				}
			} catch (e) {
				return this.initialFilter;
			}
		},
		headerSort(field){

			this.currentHeaderSort = this.currentHeaderSort == 'asc' ? 'desc' : 'asc'
			this.sortBy = JSON.parse(`{"${field}": "${this.currentHeaderSort}"}`)
			this.getCourses()
		},
		calculateUrl(id) {
			const partnerKey = localStorage.getItem('partner_client_key');

			let prefix;
			if(location.href.includes('/tfs/nuxt')){
				prefix = partnerKey ? '/tfs/nuxt/a' : '/tfs/nuxt/c';
			}else{
				prefix = partnerKey ? '/a' : '/c';
			}

			const partnerNonce = this.$route.query['partner-nonce'] ? `?partner-nonce=${this.$route.query['partner-nonce']}` : '';
			const partnerId = this.$route.query['partner_id'] ? `&partner_id=${this.$route.query['partner_id']}` : '';
			return `${prefix}${id}${partnerNonce}${partnerId}`;
		},
		redirectToCourse(url) {
			window.location.href = url;
		},
		async getCourses() {
			this.attempts++;
			this.noResults = false;
			this.isChanging = true;
			let filter = this.filterObj();
			const filterRequest = {"tags": {"included": []}};
			//add any additional filters to the request that are persisted in the route query
			if(filter){
				for (const [key, value] of Object.entries(filter)) {
					if(key === 'tags'){
						if(value.included) {
							if (value.included.includes('song lessons')) this.category = `Songs`;
							filterRequest.tags.included = value.included;
						}
						if(value.excluded) filterRequest.tags.excluded = value.excluded;
						if(value.optional) filterRequest.tags.optional = value.optional;
						continue;
					}
					filterRequest[key] = value;
				}
			}
			
			if(this.filterTags.length > 0){
				filterRequest.tags.included.push(...this.filterTags);
			}

			try {
				const searchObj = {
					"set": this.setQuery,
					"size": this.numPerPage,
					"page": this.pageNumber,
					"query": this.query,
					'partner-nonce': this.partnerNonce,
					"sort": this.sortBy,
					"fields": ["id", "yotpo", "title", 'educator', "url", "release_date:unixtime", "tags", "sales_score", "favorite", 'is_new', 'banner', {
						"image_url": { "art": "VThumb_300" }
					}],
					"filter": filterRequest
				};
				const searchResults = await this.$search.search(searchObj);

				if (searchResults.error) {
					this.errorFetching = true;
					this.errorMessage = searchResults.error;
				} else {
					filter = null;
					this.errorFetching = false;
					this.processSearchResults(searchResults);
				}
			} catch (error) {
				this.errorFetching = true;
				this.errorMessage = `Unexpected error: ${error}`;
			} finally {
				this.isFetching = false;
			}
		},
		processSearchResults(searchResults) {
			if (searchResults.summary && (searchResults.summary.pages)) {
				this.isChanging = false
				const summary = searchResults.summary;
				this.tags = summary.tags;
				this.paginationData.totalPages = summary.pages;
				this.paginationData.totalRecords = summary.total_records;
				this.paginationData.numPageOptions = this.calcNumPageOptions(summary.total_records);
				/*if (this.paginationData.totalRecords < this.numPerPage) {
					this.numPerPage = Math.pow(2, Math.ceil(Math.log2(this.paginationData.totalRecords)));
				} else if (this.numPerPage != 8 && this.numPerPage != 16 && this.numPerPage != 32) this.numPerPage = 8;*/
				for(let i = 0; i < searchResults.objects.length; i++){
					if(searchResults.objects[i].release_date){
						const releaseDate = new Date(searchResults.objects[i].release_date * 1000)
						searchResults.objects[i].releaseDate = releaseDate.toLocaleString('en-US', {year: 'numeric', day: 'numeric', month: 'numeric'})
					}
				}
				this.courses.items = searchResults.objects;
				this.isFetching = false
				
			} else {
				
				this.noResults = true
			}
		},
		updateFilter(tags, doPushHistory=true) {
			if (!tags) tags = [];
			this.isFetching = true
			this.filterTags = tags;
			this.pageNumber = 1; // reset to first page
			this.getCourses();
			// save selected tags for browser history
			if (doPushHistory) {
				try {
					window.history.pushState(this.historyObj, '');
					console.log('updateFilter', this.historyObj);
				} catch (e) {
					console.log('Unable to store selected tags in browser history', e);
				}
			}
		},
		clearFilter() {
			this.isFetching = true
			this.selectedTags = [];
			this.updateFilter();
		},
		updateSort(sortBy = this.sortBy) {
			this.isFetching = true
			this.sortBy = sortBy;
			console.log('sortBy:', this.sortBy)
			this.getCourses();
		},
		updatePagination(num = this.numPerPage, page = this.pageNumber, doPushHistory=true) {
			this.isFetching = true
			this.numPerPage = num;
			this.pageNumber = page;
			this.getCourses();
			if (doPushHistory) {
				try {
					window.history.pushState(this.historyObj, '');
					console.log('updatePagination', this.historyObj);
				} catch (e) {
					console.log('Unable to store pagination in web history', e);
				}
			}
		},
		updateSearch(searchQuery) {
			this.isFetching = true
			this.selectedTags = []
			this.filterTags = []
			this.courses.items = []
			this.paginationData = {
				totalRecords: 24,
				totalPages: 3,
				numPageOptions: 3,
			},
			this.pageNumber = 1;
			this.query = searchQuery
			this.getCourses()
		},
		calcNumPageOptions(totalRecords) {
			return Math.min(3, Math.ceil(totalRecords / this.numPerPage));
		},
		setupStyle() {
			if (process.client && typeof document !== 'undefined' && this.playerConfig && (this.playerConfig.colors)) {
				const head = document.getElementsByTagName('head')[0],
					s = document.createElement('style')
				let cssStr = ``
				if (this.playerConfig.colors.primary) {
					const pRGB = this.playerConfig.colors.primary.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
						.substring(1).match(/.{2}/g)
						.map(x => parseInt(x, 16))
					cssStr += `:root {
						--wl-primary: ${this.playerConfig.colors.primary};
						--bs-link-color-rgb: ${pRGB[0]}, ${pRGB[1]}, ${pRGB[2]};
						--bs-link-hover-color-rgba: ${pRGB[0]}, ${pRGB[1]}, ${pRGB[2]}, 0.9;
						}`
					if (this.playerConfig.font) {
						const fontLink = document.createElement('link')
						fontLink.rel = 'stylesheet'
						// fontLink.href = `https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap`
						fontLink.href = this.playerConfig.font.url
						head.appendChild(fontLink)
						cssStr += `* {font-family:${this.playerConfig.font.family} !important;} `
						if(this.playerConfig.font.fontSizeAdjust)
							cssStr += `* {font-size-adjust: ${this.playerConfig.font.fontSizeAdjust} !important;} `
					}
					cssStr += `.hoverLink {transition:opacity .1s;}
						.hoverLink:hover {opacity:0.9;}
						.btn-primary {background-color:var(--wl-primary) !important;border-color:var(--wl-primary) !important;}
						.bg-primary {background-color:var(--wl-primary) !important;}
						a {color: rgb(var(--bs-link-color-rgb)) !important;}
							a:hover {color:rgba(var(--bs-link-hover-color-rgba)) !important}
						.page-link {color:rgb(var(--bs-link-color-rgb)) !important;}
					  .page-link.active {
					  	background-color: var(--wl-primary) !important;border-color: var(--wl-primary) !important;color:white !important;}
					  .form-control:focus, .form-select:focus {
					  	border-color:var(--wl-primary) !important;box-shadow: 0 0 0 .25rem rgba(var(--bs-link-color-rgb), .25) !important;}
						.form-check-input:focus {
							border-color:var(--wl-primary) !important;box-shadow: 0 0 0 .25rem rgba(var(--bs-link-color-rgb), .25) !important;}
						.form-check-input:checked {
							background-color:var(--wl-primary) !important;border-color:var(--wl-primary) !important;}`
				}
				s.appendChild(document.createTextNode(cssStr))
				head.appendChild(s)
			}
		},
		checkHeight(){
			if (process.client && typeof document !== 'undefined') {
				window.parent.postMessage({message: JSON.stringify({height: document.body.scrollHeight + 40})}, '*')
			}
			setTimeout(this.checkHeight, 1000)
		}
	},
	async created() {
		if(this.eid) this.educatorId = this.eid
		if (this.$route.query.filter && this.$route.query.filter.sort) this.sortBy = this.$route.query.filter.sort;
		this.isFetching = true;
		const nonce = this.$route.query['partner-nonce'];
		//const nonce = 'test-nonce-27-1-erifhtiwyalp'
		const educatorSet = await this.$search.getEducatorSet();
		this.sortData = []
		this.sortData.push({
			label: `Release Date - Newest to Oldest`,
			value: { 'release_date': 'desc' }
		})
		if (this.educatorId){
			this.sortData.push({ label: `Title`, value: { 'title.keyword': 'asc' } })
		} else {
			this.sortData.push({ label: `Educator Name`, value: { 'educator.name.keyword': 'asc' } })
		}
		this.sortBy = this.sortData[0].value
		if (typeof nonce == 'undefined' && educatorSet != false) {
			this.setupStyle()
			this.query = ''
			if (educatorSet) this.setQuery = educatorSet;
			this.isFetching = true
			this.getCourses()
		} else {
			try {
				await this.$member.partnership.fromNonce(nonce);
				this.playerConfig = await this.$member.config.player();	
				if (this.playerConfig && this.playerConfig.directory && this.playerConfig.directory.pagination && this.playerConfig.directory.pagination.per_page) {
					if (this.playerConfig.directory.pagination.per_page == 'disabled') this.showPerPage = false;
				}
				this.setupStyle()
				this.query = ''
				this.setQuery = this.playerConfig.set

				const educatorSet = await this.$search.getEducatorSet();
				if (educatorSet) this.setQuery = educatorSet;
				else this.setQuery = this.playerConfig.set

				this.isFetching = true
				this.getCourses()

				console.log('---- APP MEMBER ---', this.$store.state.member)
				if(this.$store.state.member && (this.$store.state.member.auth_token)){
					window.parent.postMessage({message: JSON.stringify({token: this.$store.state.member.auth_token})}, '*')
				}

				const pinForm = await this.$member.config.pinForm()
				try {
					if (pinForm && (pinForm.form_key)) this.hasPinForm = true
				} catch (err) {
				}

			} catch (err) {
			}
		}
	},
	mounted() {
		if(window && (window.parent)) this.checkHeight()
		this.$nextTick(() => {
			window.addEventListener('popstate', (e) => {
				console.log('popstate', e.state)
				// retrieve tags saved in history when user hits back button
				if (e.state) {
					if (JSON.stringify(this.selectedTags) != JSON.stringify(e.state.tags)) {
						this.selectedTags = e.state.tags ? e.state.tags : [];
						this.updateFilter(e.state.tags, false);
					} else if ((this.numPerPage != e.state.numPerPage) || (this.pageNumber != e.state.pageNumber)) {
						this.updatePagination(
							e.state.numPerPage ? e.state.numPerPage : this.numPerPage, 
							e.state.pageNumber ? e.state.pageNumber : this.pageNumber, 
							false
						);
					}
				}
			})
		})
	}
}
